import { ProductPurchaseOption, ProductPurchaseType } from '../productMap';
import { NewM1Data } from './IN';
import { CurrencySymbol } from 'components/shared/CurrencySymbol';
export const newM1Data: NewM1Data = {
  [ProductPurchaseOption.oneTimePurchase]: {
    title: 'One Time Purchase',
    defaultProduct: ProductPurchaseType.otp_3_month_ae,
    directCheckout: false,
    plans: {
      [ProductPurchaseType.otp_1_month_ae]: {
        displayName:
          'Ultrahuman M1 Live | 1 Month Trial continuous glucose monitoring',
        price: 850,
        variantId: 'gid://shopify/ProductVariant/44186161086706',
        internalPid: ProductPurchaseType.otp_1_month_ae,
        secondaryImage: '',
        title: '1 Month',
        subtitle1: '2 CGM Sensors',
        subtitle2: 'Delivery on purchase',
      },
      [ProductPurchaseType.otp_3_month_ae]: {
        displayName:
          'Ultrahuman M1 Live | 3 Months continuous glucose monitoring',
        price: 2255,
        variantId: 'gid://shopify/ProductVariant/44187468824818',
        internalPid: ProductPurchaseType.otp_3_month_ae,
        secondaryImage: '',
        title: '3 Months',
        subtitle1: '6 CGM Sensors',
        subtitle2: 'Delivery on purchase',
        tag: <>save {CurrencySymbol.aed}295</>,
      },
      [ProductPurchaseType.otp_6_month_ae]: {
        displayName:
          'Ultrahuman M1 Live | 6 Months continuous glucose monitoring',
        price: 4755,
        variantId: 'gid://shopify/ProductVariant/44187592786162',
        internalPid: ProductPurchaseType.otp_6_month_ae,
        secondaryImage: '',
        title: '6 Months',
        subtitle1: '13 CGM Sensor',
        subtitle2: 'Delivery in batches',
        tag: <>save {CurrencySymbol.aed}770</>,
      },
      [ProductPurchaseType.otp_1_year_ae]: {
        displayName:
          'Ultrahuman M1 Live | 1 Year continuous glucose monitoring',
        price: 8955,
        variantId: 'gid://shopify/ProductVariant/44579593978098',
        internalPid: ProductPurchaseType.otp_1_year_ae,
        secondaryImage: '',
        title: '1 Year',
        subtitle1: '26 CGM Sensor',
        subtitle2: 'Delivery in batches',
        tag: <>save {CurrencySymbol.aed}2,095</>,
      },
    },
  },
  [ProductPurchaseOption.membership]: {
    title: 'Recurring Subscription',
    defaultProduct: ProductPurchaseType.membership_1_sensor_month_ae,
    directCheckout: false,
    plans: {
      [ProductPurchaseType.membership_1_sensor_month_ae]: {
        title: '2 Sensors',
        price: 815,
        subtitle1: '2 CGM Sensors/Month',
        subtitle2: '',
        internalPid: ProductPurchaseType.membership_1_sensor_month_ae,
        variantId: 'gid://shopify/ProductVariant/44218367443186',
        planId: 11113114,
      },
    },
  },
};
